import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { FaFacebookF, FaGoogle, FaTwitter } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import TextField from '@mui/material/TextField';
import RegularButton from '../../components/Buttons/RegularButton';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    useGoogleAuthDetailsMutation,
    useLoginUserMutation,
    useSsoLoginUserMutation,
} from '../../redux/services/authApi';
import { getUserData, selectJwtToken, setUser } from '../../redux/slices/authSlice';
import toast from 'react-hot-toast';
import { Alert } from '@mui/material';
import { useFindCustomerDetailByIdMutation } from '../../redux/services/customerService';
import { auth, facebook, google, twitter } from '../../config/firebase';
import { FacebookAuthProvider, GoogleAuthProvider, signInWithPopup, TwitterAuthProvider } from 'firebase/auth';
import * as Yup from 'yup';
import { useAppDispatch, useAppSelector } from '../../redux/app/hooks';
import { setCustomer } from '../../redux/slices/customerSlice';
type Props = {
    navigation?: any;
    route?: any;
    guestLoginResponse?: any
};

const SignInSchema = Yup.object().shape({
    username: Yup.string().max(40).required(' Email is required'),
    password: Yup.string().required('Password is required').min(6, 'Password is too short'),
});

const GuestLoggIn = (props: Props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loginUser, loginResponse] = useLoginUserMutation();
    const [ssoLoginUser, ssoLoginResponse] = useSsoLoginUserMutation();
    const [googleAuthDetails, googleAuthResponse] = useGoogleAuthDetailsMutation();
    const location: any = useLocation();

    const [authenticationData, setAuthenticationData] = useState<null | any>(null);
    const [googleData, setGoogleData] = useState<null | any>(null);
    const userData = useSelector(getUserData);
    const [findCustomerDetailById, findByIdResponse] = useFindCustomerDetailByIdMutation();
    const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
    const token: string = currentUser?.jwtToken;

    const [errorMessage, setErrorMessage] = useState('');

    const handleLogin = (values: any) => {
        loginUser({
            username: values.username,
            password: values.password,
            category: 'UTCUST'
        });
    };

    const loginWithSocialMedia = (
        email: string,
        name: string,
        gaccessToken: string,
        gidToken: string,
        gid: string,
        gpicture: string
    ) => {
        ssoLoginUser({
            email: email,
            name: name,
            gaccessToken: gaccessToken,
            gid: gidToken,
            gidToken: gid,
            gimageUrl: gpicture,
        });
    };

    useEffect(() => {
        if (loginResponse.isSuccess) {
            if (loginResponse.data.categoryType !== 'UTCUST') {
                navigate('/profile/auth/login');
            } else {
                props.guestLoginResponse(loginResponse.isSuccess)
                toast.success('Succesfully logged in ');
                dispatch(setUser(loginResponse.data));
                localStorage.setItem('user', JSON.stringify(loginResponse.data));
                localStorage.setItem('isLoggedIn', 'true');

            }
        } else if (loginResponse.isError) {
            let errorData: any = loginResponse.error;
            let errorMessage = errorData.error || errorData.data.serviceErrors[0].msg;
            setErrorMessage(errorMessage)
            toast.success('error');

        }
        // login by google account
        if (ssoLoginResponse.isSuccess) {
            toast.success('Succesfully logged in ');
            props.guestLoginResponse(ssoLoginResponse.isSuccess)
            dispatch(setUser(ssoLoginResponse.data));
            localStorage.setItem('user', JSON.stringify(ssoLoginResponse.data));
            localStorage.setItem('isLoggedIn', 'true');
        } else if (ssoLoginResponse.isError) {
            toast.success('Invalid username or password');
        }
    }, [loginResponse.isSuccess || loginResponse.isError, ssoLoginResponse.isSuccess || ssoLoginResponse.isError]);

    useEffect(() => {
        if (currentUser) {
            findCustomerDetailById({
                token: token,
                id: currentUser.customerId,
            });
        }
    }, []);


    useEffect(() => {
        if (findByIdResponse.isSuccess) {
            dispatch(setCustomer(findByIdResponse.data));
            localStorage.setItem(
                "customerDetail",
                JSON.stringify(findByIdResponse.data)
            );
        }
    }, [findByIdResponse.isSuccess]);

    const SignInWithGoogle = () => {
        let google_provider = google;
        signInWithPopup(auth, google_provider)
            .then((result) => {
                const credential = GoogleAuthProvider.credentialFromResult(result);
                const token = credential?.accessToken;
                setAuthenticationData(credential?.accessToken);
                const user = result.user;
                setGoogleData(user);
                if (result.user.emailVerified === true) {
                    googleAuthDetails({
                        token: token,
                    });
                }
            })
            .catch((error) => {
                toast.success(error.code, error.message);
                const errorCode = error.code;
                const errorMessage = error.message;
                const email = error.customData.email;
                const credential = GoogleAuthProvider.credentialFromError(error);
            });
    };

    const SignInWithFaceBook = () => {
        const facebook_provider = facebook;
        signInWithPopup(auth, facebook_provider)
            .then((result) => {
                const user = result.providerId;
                const credential = FacebookAuthProvider.credentialFromResult(result);
                setAuthenticationData(credential?.accessToken);
                const accessToken = credential?.accessToken;
                if (credential?.accessToken !== null) {
                    ssoLoginUser({
                        email: result?.user?.providerData?.[0]?.email,
                        name: result?.user?.displayName,
                        fbAccessToken: authenticationData?.accessToken,
                        fbId: authenticationData?.idToken,
                        fbImageUrl: result?.user?.photoURL,
                    });
                }
            })
            .catch((error) => {
                toast.success(error.code, error.message);
                const errorCode = error.code;
                const errorMessage = error.message;
                const credential = FacebookAuthProvider.credentialFromError(error);
            });
    };

    const SignInWithTwitter = () => {
        const twitter_provider = twitter;
        signInWithPopup(auth, twitter_provider)
            .then((result) => {
                const credential = TwitterAuthProvider.credentialFromResult(result);
                setAuthenticationData(credential?.accessToken);
                const token = credential?.accessToken;
                const secret = credential?.secret;
                const user = result.user;
                if (credential?.accessToken !== null) {
                    ssoLoginUser({
                        email: result?.user?.providerData?.[0]?.email,
                        name: result?.user?.displayName,
                        taccessToken: authenticationData?.accessToken,
                        tid: authenticationData?.idToken,
                        timageUrl: result?.user?.photoURL,
                    });
                }
            })
            .catch((error) => {
                toast.success(error.code, error.message);
                const errorCode = error.code;
                const errorMessage = error.message;
                const credential = TwitterAuthProvider.credentialFromError(error);
            });
    };

    useEffect(() => {
        if (googleAuthResponse.isSuccess) {
            loginWithSocialMedia(
                googleData?.email,
                googleAuthResponse.data.name,
                authenticationData?.accessToken,
                authenticationData?.idToken,
                authenticationData?.idToken,
                googleAuthResponse.data.picture
            );
        } else if (googleAuthResponse.isError) {
            toast.success('Error ocurred');
        }
    }, [googleAuthResponse.isSuccess, googleAuthResponse.isError]);

    function redirectTo(routeTo: string) {
        if (routeTo !== undefined && routeTo !== null) {
            navigate(location.state?.routeTo, {
                state: location.state,
            });
        } else {
            navigate('/');
        }
    }

    return (
        <div
        >
            <div className="p-[10px] md:p-3 md:flex md:items-center  md:flex-col flex items-center justify-center">
                <div
                    className="w-full"
                >
                    <Formik
                        validationSchema={SignInSchema}
                        initialValues={{
                            username: '',
                            password: '',
                        }}
                        onSubmit={handleLogin}
                    >
                        {({ handleBlur, handleChange, handleSubmit, values, touched, errors }) => (
                            <div>
                                <div className="mt-3">
                                    <TextField
                                        label="Email"
                                        variant="outlined"
                                        type="text"
                                        id="username"
                                        name="username"
                                        value={values.username}
                                        onChange={handleChange}
                                        placeholder="Enter your email"
                                        className="w-full"
                                        error={Boolean(touched.username && errors.username)}
                                        helperText={touched.username && errors.username}
                                        sx={{
                                            backgroundColor: "#E2E2E2",
                                            borderRadius: "30px",
                                            mb: 2,
                                            height: "45px", // Slightly reduced height for a compact look
                                            "& .MuiInputBase-root": {
                                                display: "flex",
                                                alignItems: "center", // Centers input text vertically
                                                height: "100%",
                                                padding: "0 12px", // Reducing padding inside input container
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "30px",
                                                height: "100%",
                                                "& input": {
                                                    padding: "6px 8px", // Reduced padding inside input field
                                                },
                                                "& fieldset": { borderColor: "transparent" },
                                                "&:hover fieldset": { borderColor: "transparent" },
                                                "&.Mui-focused fieldset": { borderColor: "transparent" },
                                            },
                                            "& .MuiInputLabel-root": {
                                                top: "50%",
                                                left: "12px", // Moves label closer to start
                                                transform: "translateY(-50%)", // Centers label vertically
                                            },
                                            "& .MuiInputLabel-shrink": {
                                                top: 6, // Moves label up when focused
                                                transform: "translateY(-100%) scale(0.75)",
                                            },
                                            "& .MuiFormHelperText-root": {
                                                position: "absolute",
                                                bottom: "-18px", // Adjusted for better spacing
                                                fontSize: "12px",
                                                color: "red",
                                            },
                                        }}

                                    />
                                </div>
                                <div className="mt-3">
                                    <TextField
                                        label="Password"
                                        variant="outlined"
                                        type="password"
                                        id="password"
                                        name="password"
                                        value={values.password}
                                        onChange={handleChange}
                                        placeholder="Enter your password"
                                        className="w-full"
                                        error={Boolean(touched.password && errors.password)}
                                        helperText={touched.password && errors.password}
                                        sx={{
                                            backgroundColor: "#E2E2E2",
                                            borderRadius: "30px",
                                            mb: 2,
                                            height: "45px", // Slightly reduced height for a compact look
                                            "& .MuiInputBase-root": {
                                                display: "flex",
                                                alignItems: "center", // Centers input text vertically
                                                height: "100%",
                                                padding: "0 12px", // Reducing padding inside input container
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "30px",
                                                height: "100%",
                                                "& input": {
                                                    padding: "6px 8px", // Reduced padding inside input field
                                                },
                                                "& fieldset": { borderColor: "transparent" },
                                                "&:hover fieldset": { borderColor: "transparent" },
                                                "&.Mui-focused fieldset": { borderColor: "transparent" },
                                            },
                                            "& .MuiInputLabel-root": {
                                                top: "50%",
                                                left: "12px", // Moves label closer to start
                                                transform: "translateY(-50%)", // Centers label vertically
                                            },
                                            "& .MuiInputLabel-shrink": {
                                                top: 6, // Moves label up when focused
                                                transform: "translateY(-100%) scale(0.75)",
                                            },
                                            "& .MuiFormHelperText-root": {
                                                position: "absolute",
                                                bottom: "-18px", // Adjusted for better spacing
                                                fontSize: "12px",
                                                color: "red",
                                            },
                                        }}
                                    />
                                </div>
                                {
                                    errorMessage &&
                                    <div className='mt-3 text-center text-rose-600'>
                                        <p className='text-sm '>{errorMessage}</p>
                                    </div>
                                }
                                <div className="lg:flex sm:flex-row items-center gap-5 mt-5 ">
                                    <RegularButton
                                        onClick={() => {
                                            handleSubmit();
                                        }}
                                        className="w-full"
                                        title={'Login'}
                                    />
                                </div>
                                <div className='block md:flex justify-center mb-0 text-sm text-gray-500 mt-4 cursor-default'>
                                    <p>Forgot your password?</p>
                                    <span className='text-blue-500 text-sm cursor-pointer'
                                        onClick={() => {
                                            navigate('/profile/auth/forget-password');
                                        }}
                                    >
                                        Click here
                                    </span>
                                </div>
                                {/* <div >
                                    <p className="mb-0 text-center text-gray-500 py-4">Or continue with</p>
                                    <div className="flex items-center justify-center gap-2">
                                        <button
                                            className=" shadow-xl bg-white-200 hover:bg-blue-300 transition-all h-10 w-10 rounded-lg flex items-center justify-center text-blue-500"
                                            onClick={SignInWithTwitter}
                                        >
                                            <FaTwitter />
                                        </button>
                                        <button
                                            className=" shadow-xl bg-white-200 hover:bg-blue-300 transition-all h-10 w-10 rounded-lg flex items-center justify-center text-blue-500"
                                            onClick={SignInWithGoogle}
                                        >
                                            <GoogleLoginPage />
                                            <FcGoogle />
                                        </button>
                                        <button
                                            className="shadow-xl bg-white-200 hover:bg-blue-300 transition-all h-10 w-10 rounded-lg flex items-center justify-center text-[#2f477a]"
                                            onClick={SignInWithFaceBook}
                                        >
                                            <FaFacebookF />
                                        </button>
                                    </div>
                                </div> */}
                            </div>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    );
};
export default GuestLoggIn;
